import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessagePopService {
  public notifySubject = new Subject();

  constructor() {
  }

}

export const MessagePopConstants = {
  SUCCESS: "alert-success",
  FAILURE: "alert-danger",
  INFO: "alert-info",
};

export interface MessagePopConfig {
  subject: string;
  message: string;
  status: string;
  timeDelay?: number;
}
